// Single source of truth for the public installer/user count shown on
// marketing surfaces (homepage stat, About story, blog CTA, facts page).
// Owner-approved display value; check against `select count(*) from
// auth.users` before changing it.
export const INSTALLERS_DISPLAY = "8,000+";
// Bare variant for "more than X installers" sentences.
export const INSTALLERS_BARE = "8,000";
